import React, { useState, useRef, useEffect, useContext, useMemo } from "react";
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import AdminService from "../../services/admin/admin.services";
import { useQuery } from "@tanstack/react-query";
import { useToast } from "../../utils/toast";
import { confirmDialog } from "primereact/confirmdialog";
import { FilterMatchMode } from "primereact/api";
import { UpdateProfileDto, UserDto } from "../../services/account/account.dto";
import { Link, useNavigate } from "react-router-dom";
import { commonFilterContains, commonFilterDateIs, CreateHeader, Filter } from "../filter/base-filter";
import { useFormik } from "formik";
import classNames from "classnames";
import { AutoComplete, AutoCompleteChangeEvent } from "primereact/autocomplete";
import { Dialog } from "primereact/dialog";
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import accountService from "../../services/account/account.service";
import FormikValueIsValid from "../../utils/FormikValueIsValid";
import DropdownDatas from "../../utils/DropdownValues";
import { ConfirmPopup } from "primereact/confirmpopup";
import { confirmPopup } from "primereact/confirmpopup";
import { InputSwitchChangeEvent } from "primereact/inputswitch";
import { Role } from "../../services/auth/auth.dto";

const UsersPage = () => {
  const [filters, setFilters] = useState<DataTableFilterMeta>({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS }
  });
  const [globalFilterValue, setGlobalFilterValue] = useState<string>("");
  const dt = useRef<DataTable<UserDto[]>>(null);
  const toast = useToast();
  const navigate = useNavigate();
  const [visibleUpdateUserDialog, setVisibleUpdateUserDialog] = useState<boolean>(false);
  const [selectedUser, setSelectedUser] = useState<UserDto>();
  const [selectedOSB, setSelectedOSB] = useState<any>(null);
  const allCountries = DropdownDatas.getOSBList();
  const [filteredCountries, setFilteredCountries] = useState<any[]>([]);

  const search = (event: { query: string }) => {
    const query = event.query.toLowerCase();
    const filtered = allCountries.filter(item => item.label.toLowerCase().includes(query));
    setFilteredCountries(filtered);
  };

  //   const { data: userResponse, refetch: refetchUsers, isLoading: userResponseIsLoading } = useQuery({
  //     queryKey: ["Users"],
  //     refetchOnMount: true,
  //     queryFn: () => AdminService.GetAllUser()
  //   });

  const { data: userResponse, refetch: refetchUsers, isLoading: userResponseIsLoading, isError, error } = useQuery({
    queryKey: ["Users"],
    refetchOnMount: true,
    queryFn: async () => {
      const res = await AdminService.GetAllUser();
      if (res?.result?.error != null) {
        toast.show(res?.result?.error || "Hata oluştu.", "error");
      }
      return res;
    }
  });

  const exportCSV = () => {
    dt.current?.exportCSV();
  };

  const clearFilter = () => {
    initFilters();
  };

  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      first_name: commonFilterContains,
      last_name: commonFilterContains,
      email: commonFilterContains
      //creationTime: commonFilterDateIs
    });
    setGlobalFilterValue("");
  };

  useEffect(() => {
    initFilters();
  }, []);

  const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    let _filters = { ...filters };
    // @ts-ignore
    _filters["global"].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const actionBodyTemplate = (rowData: UserDto) => {
    return (
      <div className="flex justify-content-center">
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          tooltip="Düzenle"
          severity="success"
          className="mr-2"
          onClick={() => {
            setSelectedUser(rowData);
            setVisibleUpdateUserDialog(true);
            if (rowData) {
              formik.setFieldValue("first_name", rowData.first_name);
              formik.setFieldValue("last_name", rowData.last_name);
              formik.setFieldValue("email", rowData.email);
              formik.setFieldValue("phone_number", rowData.phone_number);
              formik.setFieldValue("osb", rowData.osb);
              setSelectedOSB(rowData.osb);
              formik.setFieldValue("osb_gorevi", rowData.osb_gorevi);
            } else {
              toast.show("Kullanıcı bilgileri alınamadı", "error");
            }
          }}
        />
        {rowData.request_osbuk_user && rowData.role === Role.USER && (
          <div>
            <ConfirmPopup />
            <Button
              icon="pi pi-angle-double-up"
              rounded
              outlined
              tooltip="Kullanıcıyı OSBUK Kullanıcısı Yap"
              severity="info"
              className="mr-2"
              onClick={event => {
                setSelectedUser(rowData);
                confirmPopup({
                  target: event.currentTarget,
                  message: "Onaylıyor musunuz?",
                  icon: "pi pi-info-circle",
                  defaultFocus: "accept",
                  acceptClassName: "p-button-success",
                  acceptLabel: "Onayla",
                  rejectLabel: "İptal",
                  accept: async () => {
                    AdminService.MakeOsbukUser(rowData.id).then(res => {
                      if (!res?.result?.error) {
                        toast.show("Kullanıcı başarıyla OSBUK kullanıcısı yapıldı", "success");
                      } else {
                        toast.show(res?.result?.error || "Kayıt işlemi sırasında bir hata oluştu.", "error");
                      }
                    });
                  },
                  reject: () => {}
                });
              }}
            />
          </div>
        )}
      </div>
    );
  };

  const formik = useFormik<UpdateProfileDto>({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      osb: "",
      osb_gorevi: "",
      request_osbuk_user: false
    },
    enableReinitialize: true,
    validate: data => {
      const errors: any = {};
      if (!data.first_name) {
        errors.first_name = "İsim gereklidir";
      }

      if (!data.last_name) {
        errors.last_name = "Soyad gereklidir";
      }

      if (!data.email) {
        errors.email = "Email gereklidir";
      }

      if (!data.phone_number) {
        errors.phone_number = "Telefon numarası gereklidir";
      }

      if (!data.osb) {
        errors.osb = "OSB gereklidir";
      }

      if (!data.osb_gorevi) {
        errors.osb_gorevi = "OSB görevi gereklidir";
      }

      return errors;
    },
    onSubmit: values => {
      accountService.UpdateProfile(values).then(res => {
        if (!res?.result?.error) {
          toast.show("Profil başarıyla güncellendi", "success");
          //navigate("/");
        } else {
          toast.show(res?.result?.error || "Kayıt işlemi sırasında bir hata oluştu.", "error");
        }
      });
    }
  });

  const sortedData = useMemo(() => {
    return (
      userResponse?.result?.data?.sort((a, b) => {
        if (a.request_osbuk_user === true && a.role === Role.USER) return -1;
        if (b.request_osbuk_user === true && b.role === Role.USER) return 1;
        return 0;
      }) || []
    );
  }, [userResponse]);

  return (
    <>
      <Dialog
        header={selectedUser?.first_name + " " + selectedUser?.last_name + " - "}
        visible={visibleUpdateUserDialog}
        maximizable
        style={{ width: "90%", height: "75%" }}
        onHide={() => {
          setVisibleUpdateUserDialog(false);
        }}
        id="dosyaDialog"
      >
        <div className="card p-1 lg:p-5">
          <form className="flex align-items-center justify-content-center pt-5" onSubmit={formik.handleSubmit}>
            <div className="flex flex-column align-items-center justify-content-center">
              <div className="grid">
                <div className="col-12 md:col-6">
                  <label htmlFor="first_name" className="text-primary">
                    {"İsim"}
                  </label>
                  <InputText
                    id="first_name"
                    type="text"
                    placeholder={"İsim"}
                    className={classNames("w-full  mt-2", {
                      "p-invalid": FormikValueIsValid(formik, "first_name")
                    })}
                    value={formik.values.first_name}
                    onChange={e => formik.setFieldValue("first_name", e.target.value)}
                    style={{ padding: "1rem" }}
                  />
                  {FormikValueIsValid(formik, "first_name") && (
                    <div className="p-error mt-3">{formik.errors.first_name}</div>
                  )}
                </div>
                <div className="col-12 md:col-6">
                  <label htmlFor="last_name" className="text-primary">
                    Soy isim
                  </label>
                  <InputText
                    id="last_name"
                    type="text"
                    placeholder="Soy isim"
                    className={classNames("w-full  mt-2", {
                      "p-invalid": FormikValueIsValid(formik, "last_name")
                    })}
                    value={formik.values.last_name}
                    onChange={e => formik.setFieldValue("last_name", e.target.value)}
                    style={{ padding: "1rem" }}
                  />
                  {FormikValueIsValid(formik, "last_name") && (
                    <div className="p-error mt-3">{formik.errors.last_name}</div>
                  )}
                </div>

                <div className="col-12 md:col-6">
                  <label htmlFor="email" className="text-primary">
                    {"E-Posta Adresi"}
                  </label>
                  <InputText
                    id="email"
                    type="email"
                    placeholder={"E-Posta Adresi"}
                    className={classNames("w-full")}
                    value={formik.values.email}
                    onChange={e => formik.setFieldValue("email", e.target.value)}
                    style={{ padding: "1rem" }}
                  />
                  {FormikValueIsValid(formik, "email") && <div className="p-error mt-3">{formik.errors.email}</div>}
                </div>

                <div className="col-12 md:col-6">
                  <label htmlFor="phone_number" className="text-primary">
                    {"Telefon Numarası"}
                  </label>
                  <InputMask
                    id="phone_number"
                    keyfilter="int"
                    mask="(0999) 999-99-99"
                    placeholder={"Telefon Numarası"}
                    className={classNames("w-full")}
                    value={formik.values.phone_number}
                    onChange={e => formik.setFieldValue("phone_number", e.target.value)}
                    style={{ padding: "1rem" }}
                  />
                  {FormikValueIsValid(formik, "phone_number") && (
                    <div className="p-error mt-3">{formik.errors.phone_number}</div>
                  )}
                </div>
                <div className="col-12 md:col-6">
                  <label className="text-primary" htmlFor="osb">
                    Bağlı Olduğunuz OSB
                  </label>
                  <AutoComplete
                    id="osb"
                    name="osb"
                    inputId="osb"
                    value={selectedOSB}
                    suggestions={filteredCountries}
                    completeMethod={search}
                    field="label"
                    onChange={(e: AutoCompleteChangeEvent) => {
                      setSelectedOSB(e.value);
                      formik.setFieldValue("osb", e.value.value ? e.value.value : e.value);
                    }}
                    placeholder="Bağlı Olduğunuz OSB"
                    dropdown
                    className={classNames("w-full mt-2", {
                      "p-invalid": FormikValueIsValid(formik, "osb")
                    })}
                  />
                  {FormikValueIsValid(formik, "osb") && <div className="p-error mt-3">{formik.errors.osb}</div>}
                </div>
                <div className="col-12 md:col-6">
                  <label htmlFor="osb_gorevi" className="text-primary">
                    OSB'deki Göreviniz
                  </label>
                  <InputText
                    id="osb_gorevi"
                    type="string"
                    placeholder="OSB'deki Göreviniz"
                    className={classNames("w-full mt-2", {
                      "p-invalid": FormikValueIsValid(formik, "osb_gorevi")
                    })}
                    value={formik.values.osb_gorevi}
                    onChange={e => formik.setFieldValue("osb_gorevi", e.target.value)}
                  />
                  {FormikValueIsValid(formik, "osb_gorevi") && (
                    <div className="p-error mt-3">{formik.errors.osb_gorevi}</div>
                  )}
                </div>

                <div className="w-full">
                  <Button label="Güncelle" className="w-full text-xl mt-2" type="submit"></Button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Dialog>

      <div>
        <div className="card">
          {/* <Toolbar className="mb-4" end={rightToolbarTemplate}></Toolbar> */}

          <DataTable
            ref={dt}
            showGridlines
            value={sortedData}
            dataKey="id"
            paginator
            rows={100}
            rowsPerPageOptions={[10, 25, 50, 100]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="{first} / {last} - Toplam {totalRecords} ana kullanıcı"
            filters={filters}
            // filterDisplay="row"
            loading={userResponseIsLoading}
            globalFilterFields={["first_name", "last_name", "phone_number", "email", "creationTime", "role"]}
            emptyMessage="Kullanıcı bulunamadı."
            header={CreateHeader(
              "Kullanıcılar",
              globalFilterValue,
              e => onGlobalFilterChange(e),
              clearFilter,
              exportCSV
              //exportExcel
            )}
            columnResizeMode="expand"
            // rowClassName={data =>
            //   data.request_osbuk_user && data.role === "User" ? { backgroundColor: "yellow" } : {}
            // }
            rowClassName={data => (data.request_osbuk_user && data.role === Role.USER ? "bg-cyan-200" : "")}
          >
            <Column body={actionBodyTemplate} exportable={false}></Column>
            <Column
              field="first_name"
              header="İsim"
              sortable
              filterField="first_name"
              showFilterMatchModes={false}
              filter
              filterPlaceholder="İsme göre arayın"
              filterClear={Filter.FilterClearTemplate}
              filterApply={Filter.FilterApplyTemplate}
            ></Column>
            <Column
              field="last_name"
              header="Soyisim"
              sortable
              filterField="last_name"
              filter
              filterPlaceholder="Soyisime göre arayın"
              filterClear={Filter.FilterClearTemplate}
              filterApply={Filter.FilterApplyTemplate}
              filterFooter={() => {
                return <div className="px-3 pt-0 pb-3 text-center">Soyisime göre filtreleyin</div>;
              }}
            ></Column>
            <Column
              field="email"
              header="E-posta"
              sortable
              filterField="email"
              filter
              filterPlaceholder="E-posta göre arayın"
              filterClear={Filter.FilterClearTemplate}
              filterApply={Filter.FilterApplyTemplate}
              filterFooter={() => {
                return <div className="px-3 pt-0 pb-3 text-center">E-posta göre filtreleyin</div>;
              }}
            ></Column>
            <Column
              field="phone_number"
              header="Telefon Numarası"
              sortable
              filterField="phone_number"
              filter
              filterPlaceholder="Telefon Numarasına göre arayın"
              filterClear={Filter.FilterClearTemplate}
              filterApply={Filter.FilterApplyTemplate}
              filterFooter={() => {
                return <div className="px-3 pt-0 pb-3 text-center">Telefon Numarasına göre filtreleyin</div>;
              }}
            ></Column>
            <Column
              field="role"
              header="Rol"
              sortable
              filterField="role"
              filter
              filterPlaceholder="Role göre arayın"
              filterClear={Filter.FilterClearTemplate}
              filterApply={Filter.FilterApplyTemplate}
              filterFooter={() => {
                return <div className="px-3 pt-0 pb-3 text-center">Role göre filtreleyin</div>;
              }}
            ></Column>
            {/* <Column
            field="creationTime"
            header="Kayıt Tarihi"
            body={(rowData: UserDto) => {
              return <span>{rowData.creationTime ? new Date(rowData.creationTime).toLocaleDateString() : ""}</span>;
            }}
            sortable
            filterField="creationTime"
            filter
            filterPlaceholder="Kayıt Tarihine göre arayın"
            filterClear={Filter.FilterClearTemplate}
            filterApply={Filter.FilterApplyTemplate}
            filterElement={Filter.DateFilterTemplate}
            filterFooter={() => {
              return <div className="px-3 pt-0 pb-3 text-center">Kayıt Tarihine göre filtreleyin</div>;
            }}
          ></Column> */}
          </DataTable>
        </div>
      </div>
    </>
  );
};

export default UsersPage;
